module.exports = __webpack_public_path__ + "static/media/LT.4aeb2c56.wav";